


































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import VuePdfApp from 'vue-pdf-app';
import 'vue-pdf-app/dist/icons/main.css';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';
import QuestionLoading from '@/components/questions/QuestionLoading.vue';
import {
  PreCollection,
  PreCollectionContentType,
} from '@/resource/pre-collection/pre-collection.model';
import Icon from '@/main-components/common/Icon.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import PreCollectionPreviewOverlay from './PreCollectionPreviewOverlay.vue';
// import Adsense from '@/main-components/adsense/Adsense.vue';
// import PreCollectionAd from './PreCollectionAd.vue';
import { UserStatus } from '@/resource/user/user.model';
import { getPdfDownloaded, getUserStatus } from '@/utils/cookie';
import { CollectionItemModified } from '@/resource/collection-item/collection-item.model';
import CourseContent from '@/components/course/CourseContent.vue';
import { CourseItem } from '@/resource/course-item/course-item.model';

@Component({
  components: {
    PreCollectionPreviewOverlay,
    VuePdfApp,
    QuestionContainer,
    QuestionLoading,
    Icon,
    MainButton,
    // Adsense,
    // PreCollectionAd,
    CourseContent,
  },
})
export default class PreCollectionContent extends Vue {
  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  @Prop({ required: true })
  collectionItems!: CollectionItemModified[];

  @Prop({ required: true })
  isLoadingAddCollectionItems!: boolean;

  @Prop({ required: true })
  lastObjectiveQuestion!: number;

  @Prop({ required: true })
  totalSubjectiveQuestions!: number;

  @Prop({ default: true })
  isPreviewOnly!: boolean;

  @Prop({ default: true })
  isLoggedin!: boolean;

  @Prop({ required: true })
  isPurchased!: boolean;

  @Prop({ required: true })
  courseItems!: CourseItem[];

  @Prop({ default: false })
  isReachDownloadLimit!: boolean;

  pdfConfig = {
    toolbar: {},
  };

  isPdfRendered = false;
  pdfKey = 1;
  heightPapers = 10;

  get overlayDescription() {
    return !this.isLoggedin
      ? 'Daftar Mysoalan Untuk Melanggan'
      : 'Langgan Premium Untuk Melihat Semua';
  }

  get overlayButtonLabel() {
    return !this.isLoggedin ? 'Daftar Sekarang' : 'Langgan Premium';
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  get pdfDownloaded() {
    return getPdfDownloaded();
  }

  pagesRendered() {
    this.isPdfRendered = true;
    this.updatePdfHeight();
    window.addEventListener('resize', this.updatePdfHeight);

    this.$sendMpEvent({
      event: this.$mp_value.LoadTimePreCollection,
      properties: {
        contentType: PreCollectionContentType.Pdf,
      },
    });
  }

  updatePdfHeight() {
    const pages = Array.from(document.getElementsByClassName('page')) || [];

    const heightsArray = pages.map(page => page.scrollHeight);
    const maxIndex = heightsArray.indexOf(Math.max(...heightsArray));

    let currentHeight =
      pages && pages[maxIndex] && pages[maxIndex].scrollHeight;

    if (currentHeight && currentHeight < 50) {
      currentHeight = 400;
      this.pdfKey += 1;
    }

    if (currentHeight) {
      if (!this.isPremiumStatus) {
        this.heightPapers = currentHeight * 2;
      } else {
        this.heightPapers = currentHeight * pages.length;
      }
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updatePdfHeight);
  }
}
